import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Actions from '../../../../actions'
import { routes } from '../../../../consts'
import { ProfileRoutes } from '../../../../consts/Profile'
import VerifyPhoneCode from '../../VerifyPhoneCode'

import './ResetPasswordVerifyCode.css'

const ResetPasswordVerifyCode = () => {
  const dispatch = useDispatch()

  const { phone, verifyOtpCodeLoading, verifyOtpCodeErrorMessage } =
    useSelector(state => state.auth.resetPassword)

  const isAuthenticated = useSelector(state => state.auth.isLoggedIn)

  const onSendCodeAgain = phoneNumber => {
    dispatch(
      Actions.createAction(Actions.OTP_CODE_REQUESTED, {
        phone: phoneNumber,
        route: isAuthenticated
          ? ProfileRoutes.PROFILE_RESET_PASSWORD_VERIFY_CODE
          : routes.RESET_PASSWORD_VERIFY_CODE,
      })
    )
  }

  const handleNext = ({ phoneNumber, code }) => {
    dispatch(
      Actions.createAction(Actions.OTP_CODE_VERIFY_REQUESTED, {
        phone: phoneNumber,
        value: code,
        route: isAuthenticated
          ? ProfileRoutes.PROFILE_RESET_AND_CHOOSE_NEW_PASSWORD
          : routes.RESET_AND_CHOOSE_NEW_PASSWORD,
      })
    )
  }

  return (
    <VerifyPhoneCode
      onNext={({ phoneNumber, code }) => handleNext({ phoneNumber, code })}
      onResend={phone => onSendCodeAgain(phone)}
      phone={phone}
      loading={verifyOtpCodeLoading}
      errorMessage={verifyOtpCodeErrorMessage}
    />
  )
}

export default ResetPasswordVerifyCode
